import { t } from '../../i18n'
import { SelectOption } from '../shared/forms/SelectOption'
import { FILL_LEVELS, FillLevel } from '../shared/dosing_modes/fillLevels'
import { EMERGENCY_STRATEGIES, EmergencyStrategy } from './types'

export const modeLabel = (key: string) => t(`sauce_dosing_modes.${key}`)
export const paramLabel = (key: string) =>
  t(`sauce_dosing_modes.level_params.${key}`)
export const paramUnit = (key: string) =>
  t(`sauce_dosing_modes.level_units.${key}`)
export const placeholderLabel = (key: string) =>
  t(`sauce_dosing_modes.placeholders.${key}`)

export const FILL_LEVEL_OPTIONS: SelectOption<FillLevel>[] = FILL_LEVELS.map(
  (fillLevel) => ({
    value: fillLevel,
    label: t(`sauce_dosing_modes.fill_levels.${fillLevel}`)
  })
)

export const STRATEGY_OPTIONS: SelectOption<EmergencyStrategy>[] =
  EMERGENCY_STRATEGIES.map((strategy) => ({
    value: strategy,
    label: t(`sauce_dosing_modes.emergency_strategies.${strategy}`)
  }))
